import { Base } from '@studiometa/js-toolkit';

/**
 * ScrollTop component
 */
export default class Roadmap extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Roadmap',
    refs: ['stickyItems[]', 'sectionTitle[]', 'cursor[]'],
    log: true,
  };

  index = 0;

  current = 0;

  /**
   * mounted hook
   */
  mounted() {
    this.sectionTitles = document.querySelectorAll('[data-ref="sectionTitle[]"]');
    this.heightFirstSection =
      this.$refs.sectionTitle[1].offsetTop - this.$refs.sectionTitle[0].offsetTop;
    this.heightSecondSection =
      this.$refs.sectionTitle[2].offsetTop - this.$refs.sectionTitle[1].offsetTop;
    this.heightThirdSection = document.body.offsetHeight - this.$refs.sectionTitle[2].offsetTop;
    this.footerHeight =
      document.querySelector('.shopify-section-group-footer-group').offsetHeight * 2;
  }

  /**
   * Progressbar when scrolling
   * @returns {void}
   */
  scrolled() {
    if (window.scrollY < this.heightFirstSection) {
      this.percent = window.scrollY / this.heightFirstSection;
      this.index = 0;
    }

    if (
      window.scrollY > this.heightFirstSection &&
      window.scrollY < this.sectionTitles[2].offsetTop
    ) {
      this.percent = (window.scrollY - this.heightFirstSection) / this.heightSecondSection;
      this.index = 1;
    }

    if (window.scrollY > this.sectionTitles[2].offsetTop) {
      this.percent =
        (window.scrollY - this.heightFirstSection - this.heightSecondSection) /
        (this.heightThirdSection - this.footerHeight);
      this.index = 2;
    }

    if (this.current > this.index) {
      this.$refs.cursor[this.current].style.transform = `scaleX(0)`;
    }

    this.current = this.index;

    this.$refs.cursor[this.index].style.transform = `scaleX(${this.percent})`;
  }
}
